/**
 * Shared validation for finance instalments: the monthly-instalment bounds check reused by the
 * credit and leasing utils, and the guard that rejects invalid calculator-quote payments.
 */

/**
 * Shared monthly-instalment validation. The credit and leasing utils enforce the same
 * bounds check but with different limits, so the body is hoisted here and each util
 * delegates with its own bounds instead of duplicating the logic.
 */
export const isMonthlyInstalmentWithinBounds = (
  monthlyInstalment: number | null,
  mustExists: boolean,
  min: number,
  max: number,
): boolean => {
  return Boolean(
    (!mustExists && !monthlyInstalment) ||
      (monthlyInstalment && monthlyInstalment >= min && monthlyInstalment <= max),
  );
};

/**
 * Guards a monthly payment returned from the calculator (ŠkoFIN via BE) before it is
 * shown as a quote. A valid quote must be a finite, strictly-positive number; this
 * rejects null/zero/NaN/Infinity results so they are never applied. This is NOT the
 * manual-input bounds check — a low but positive payment is a valid quote here.
 */
export const isValidCalculatedPayment = (payment: number | null | undefined): boolean => {
  return typeof payment === 'number' && Number.isFinite(payment) && payment > 0;
};
